export function buildMediaErrorExtra(
  rawError: unknown,
): Record<string, unknown> {
  if (rawError instanceof Error) {
    return {
      rawErrorMessage: rawError.message,
      rawErrorName: rawError.name,
      rawErrorStack: rawError.stack,
    }
  }

  if (typeof rawError === 'string') {
    return { rawErrorMessage: rawError }
  }

  if (rawError == null) {
    return {}
  }

  try {
    return { rawErrorMessage: JSON.stringify(rawError) }
  } catch {
    return { rawErrorMessage: String(rawError) }
  }
}
